<template>
  <div id="Liangmianshujutongji">
    <div class="tr-header">
      <p class="title">号码规律统计</p>
      <div class="handles" v-if="betType != 'xyrb' && betType != 'ks'">
        <span
          @click="handleChecked('today', '0')"
          :class="{'checked': checked === '0'}"
          class="handle"
        >今天</span>
        <span
          @click="handleChecked('yesterday', '1')"
          :class="{'checked': checked === '1'}"
          class="handle"
        >昨天</span>
        <span
          @click="handleChecked('beforeYesterday', '2')"
          :class="{'checked': checked === '2'}"
          class="handle"
        >前天</span>
        <span
          @click="handleChecked('30', '3')"
          :class="{'checked': checked === '3'}"
          class="handle"
        >最近 30 期</span>
        <span
          @click="handleChecked('60', '4')"
          :class="{'checked': checked === '4'}"
          class="handle"
        >最近 60 期</span>
        <span
          @click="handleChecked('90', '5')"
          :class="{'checked': checked === '5'}"
          class="handle"
        >最近 90 期</span>
      </div>
    </div>
    <div class="tr-table-container">
      <div v-if="betType != 'ks'" class="check_box_one">
        <div v-if="dataSource.length > 0">
          <span>选着号码:</span>
          <span
            :class="{'checked_button': ballIndex == i}"
            class="handle"
            v-for="(it,i) in dataSource[0].ballList"
            :key="i"
            @click="handleBallChecked(i)"
          >号码{{i + 1}}</span>
        </div>
        <div class="chart_content" v-if="barList.length > 0">
          <v-chart :options="option" />
        </div>
      </div>
      <Table width="100%" :columns="columns" :data="dataSource" border></Table>
      <div>
        <p>1、【号码规律统计】提供号码开出位置的历史同位号码统计。例如第1期开出号码1后，在第1期开出号码1的相同位置，第2期开出号码为2，则把号码2标示</p>
        <p>2、柱形图表为历史同位开出号码的次数分布，用于查看已开出号码的分布及趋势，亦可作为参考辅助杀号。</p>
      </div>
    </div>
  </div>
</template>

<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";
import { mapState } from "vuex";

import ECharts from "vue-echarts";

import "echarts/lib/component/tooltip";
import "echarts/lib/chart/bar";
export default {
  name: "Liangmianshujutongji",
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      option: {
        color: ["#fa8e19"],
        title: {
          text: ""
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ["销量"]
        },
        xAxis: {
          data: [
            "号码1",
            "号码2",
            "号码3",
            "号码4",
            "号码5",
            "号码6",
            "号码7",
            "号码8",
            "号码9",
            "号码10"
          ]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            type: "bar",
            data: [],
            barWidth: 50 //柱图宽度
          }
        ]
      },
      columns: [],
      pageSize: 30,
      dataSource: [],
      ballIndex: 0,
      checked: "3",
      ballNum: 1,
      barList: [],
      showBallNum: false,
      startDate: ""
    };
  },
  computed: {
    ...mapState(["device"]),
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        // this.reset();
        this.getDate();
      }
    },
    device: {
      handler() {
        this.getDate();
      },
      immediate: true
    }
  },
  methods: {
    handleChecked(agt, index) {
      this.startDate = "";
      this.pageSize = "";
      this.checked = index;
      var year = dayjs().year();
      var month = ("00" + (dayjs().month() + 1)).slice(-2);
      var date = ("00" + dayjs().date()).slice(-2);
      if (agt == "today") {
        this.startDate = `${year}-${month}-${date}`;
      } else if (agt == "yesterday") {
        // date -= 1;
        date = ("00" + (date - 1)).slice(-2);
        this.startDate = `${year}-${month}-${date}`;
      } else if (agt == "beforeYesterday") {
        // date -= 2;
        date = ("00" + (date - 2)).slice(-2);
        this.startDate = `${year}-${month}-${date}`;
      } else if (agt == "30") {
        this.pageSize = 30;
      } else if (agt == "60") {
        this.pageSize = 60;
      } else if (agt == "90") {
        this.pageSize = 90;
      }
      this.getDate();
    },
    reset(data) {
      this.columns = columns(this.betType, data, this.ballIndex).list(this);
      // this.lostColumns = columns(this.betType, data).lostList(this);
    },
    async getDate() {
      // /queryKcReportByIssue.do?gameType=CQSSC
      this.barList = [];

      let req = {
        gameType: this.$route.params.gameType,
        num: this.pageSize + 1,
        date: this.startDate,
        hasLast: 1
      };
      let res = await this.$http.post("/queryKcReportByIssue.do", req);
      if (res.data.returnCode == "0000") {
        var arr = format.formatJson(res.data.returnList);

        var a = this.formatList(arr);
        var r = a.slice(0, -1);
        // console.log(r, "rrrrr");
        this.reset(a);
        this.dataSource = r;

        this.$nextTick(() => {
          var canvas = document.querySelector(".cvs_container");
          let table = document.querySelector(".ivu-table-tbody");
          if (canvas) {
            table.removeChild(canvas);
          }
          this.createCanvas();
        });
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatList(arr) {
      // barList
      if (this.device == "mobile") {
        this.option.series[0].barWidth = 20;
      }
      for (let z = 0; z < 10; z++) {
        this.barList[z] = 0;
        this.option.series[0].data[z] = 0;
      }
      for (let i = 0; i < arr.length; i++) {
        var ball = arr[i].balls.split(",");
        arr[i].ballList = ball;
      }
      for (let i = 0; i < arr.length - 1; i++) {
        var ball = arr[i];
        var ballNex = arr[i + 1];
        for (let j = 0; j < ballNex.ballList.length; j++) {
          const e = ballNex.ballList[j];
          if (e == this.ballNum) {
            ball.nowNum = ball.ballList[j];
            this.barList[ball.nowNum - 1] += 1;
            this.option.series[0].data[ball.nowNum - 1] += 1;
          }
        }
      }
      // console.log(this.barList, this.option.series, "barList");
      return arr;
    },
    handleBallChecked(i) {
      this.ballIndex = i;
      this.ballNum = i + 1;
      this.getDate();
    },
    createCanvas() {
      let table = document.querySelector(".ivu-table-tbody");

      let tablePos = table.getBoundingClientRect();

      let tableleft = tablePos.left;
      let tabletop = tablePos.top;
      //设置画布
      let cvs = document.createElement("canvas");
      cvs.style.marginTop = -table.offsetHeight + "px";
      cvs.className = "cvs_container";
      cvs.height = table.offsetHeight; // 表格的高度等同画布高度
      cvs.width = table.scrollWidth; // 表格的高度等同画布高度

      var redList = document.querySelectorAll(".red");
      // let length = this.dataSource[0].ballList.length; // 开奖球数 5  就是列数
      var length = 1;
      let redLength = redList.length; // 中奖号码球数 150

      let canvasArr = []; // 画笔坐标系
      for (let i = 0; i < length; i++) {
        canvasArr[i] = new Array();
        // console.log(i + 1, "iiii");
        // for (let j = 0; j < this.pageSize; j++) {
        for (let j = 0; j < this.dataSource.length; j++) {
          var num = i + length * j;
          let dom = redList[num];
          let pos = dom.getBoundingClientRect();
          let left = pos.left + dom.offsetHeight / 2;
          let top = pos.top + dom.offsetWidth / 2;
          let a = { left: left - tableleft, top: top - tabletop - 15 };
          canvasArr[i].push(a);
        }
      }
      for (let i = 0; i < canvasArr.length; i++) {
        let colors = {
          0: "#fba75e",
          1: "#1fa6e8",
          2: "#0abe02",
          3: "#8485fb",
          4: "#46bd94",
          5: "#e16baa",
          6: "#f2b653",
          7: "#628ef3",
          8: "#5ec642",
          9: "#f66d6d"
        };
        let color = colors[i];
        let cxt = cvs.getContext("2d"); // 画笔
        cxt.strokeStyle = color; // 颜色
        cxt.beginPath();
        let it = canvasArr[i];
        if (it.length > 0) {
          cxt.moveTo(it[0].left, it[0].top);
          for (let j = 0; j < it.length; j++) {
            cxt.lineTo(it[j].left, it[j].top);
            cxt.stroke();
          }
        }
      }
      table.append(cvs); // 将绘画好的走势图接入表格dom树
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Haomaguilvtongji/index.vue